export default __webpack_public_path__ + "static/img6-ac6cc377d3bf996874be24dc0edd7c67.png";